(() => {
  // app/scripts/product-description.js
  var requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
  var cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame;
  customElements.define("product-description-component", class productDescription extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.addEventListener("click", (e) => {
        const { target } = e;
        if (target.closest(".tab-content--heading")) {
          e.preventDefault();
          this.toggleTab(target);
        }
        if (target.closest(".jsScrollTo") && target.closest("sticky-component.active")) {
          e.preventDefault();
          this.scrollTo(target.closest(".jsScrollTo").dataset.scroll);
        }
      });
      this.template = this.querySelector("[data-variant-template]")?.content || null;
      this.updateFitmentTab();
      this.updateSpecsTab();
      const handleDescriptionUpdate = (e) => {
        if (e.detail?.currentVariant) {
          this.getURL();
        }
      };
      window.removeEventListener("description:update", handleDescriptionUpdate);
      window.addEventListener("description:update", handleDescriptionUpdate);
    }
    toggleTab(element) {
      this.querySelectorAll(".tab-content--heading.active").forEach((button) => {
        const tabEl2 = this.querySelector(`#${button.getAttribute("aria-controls")}`);
        button.classList.remove("active");
        tabEl2.classList.remove("active");
      });
      const tabEl = this.querySelector(`#${element.getAttribute("aria-controls")}`);
      element.classList.add("active");
      tabEl.classList.add("active");
    }
    scrollTo(selector) {
      const targetOffsetTop = document.querySelector(selector).getBoundingClientRect().top + document.documentElement.scrollTop;
      const bottom = this.querySelector("sticky-component").getBoundingClientRect().top;
      window.scrollTo({
        top: targetOffsetTop - bottom,
        behavior: "smooth"
      });
    }
    async getURL() {
      let url = location.href;
      url += url.includes("?") ? "&" : "?";
      url += `section_id=${this.dataset.sectionId}`;
      const response = await fetch(url);
      const sectionDescription = await response.text();
      this.updateAllTab(sectionDescription);
    }
    updateAllTab(data) {
      const div = document.createElement("div");
      div.innerHTML = data;
      let tabHeadingActive = null;
      let tabBodyActive = null;
      this.querySelectorAll(".tab-content--heading").forEach((tab) => {
        if (tab.classList.contains("active")) {
          tab.classList.remove("active", "tab-content--heading");
          const classList = Array.from(tab.classList);
          tabHeadingActive = classList[0];
        }
      });
      this.querySelectorAll(".tab-content--body").forEach((tab) => {
        if (tab.classList.contains("active")) {
          tab.classList.remove("active", "tab-content--body", "tab-content");
          const classList = Array.from(tab.classList);
          tabBodyActive = classList[0];
        }
      });
      this.innerHTML = div.querySelector("product-description-component").innerHTML;
      this.querySelectorAll(".tab-content--heading").forEach((tab) => {
        tab.classList.remove("active");
      });
      this.querySelectorAll(".tab-content--body").forEach((tab) => {
        tab.classList.remove("active");
      });
      this.querySelector(`.${tabHeadingActive.trim()}`).classList.add("active");
      this.querySelector(`.${tabBodyActive.trim()}`).classList.add("active");
      this.updateFitmentTab();
      this.updateSpecsTab();
    }
    updateFitmentTab() {
      if (this.querySelector(".table-fitment").textContent.trim() === "") {
        this.querySelector(".heading-fitment").style.display = "none";
      } else {
        this.querySelector(".heading-fitment").style.display = "block";
      }
    }
    updateSpecsTab() {
      if (this.querySelector(".panel-content-table").innerHTML.trim() === "") {
        this.querySelector(".heading-specs").style.display = "none";
      } else {
        this.querySelector(".heading-specs").style.display = "block";
      }
    }
    // updateContent(currentVariant) {
    // 	const template = this.template.querySelector(`[data-variant-id="${currentVariant?.id}"]`);
    // 	Array.from(this.querySelectorAll(".jsVariantUpdate")).forEach((node) => {
    // 	// const {updateId} = node.dataset;
    // 	//   if(!updateId.includes(this.dataset.formId)) return;
    // 	  const target = template?.querySelector(`.jsVariantUpdate[data-update-id="${node.dataset.updateId}"]`);
    // 	  node.innerHTML = target?.innerHTML || "";
    // 	  target && (node.className = target.className);
    // 	});
    // 	this.updateFitmentTab();
    // 	this.updateSpecsTab();
    // }
  });
})();
